/* eslint-disable import/no-internal-modules */
import { Component } from 'preact'
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
import { getIdAndContentTypeFromTopics, performBulkActionForTopics } from '../../utils'

import DynamicUserList from '@insided/deprecated-preact-components/list-selector/DynamicUserList'
import { User } from '@insided/deprecated-preact-components/user-selector/User'
import axios from 'axios'
import { UserListItem } from '@insided/deprecated-preact-components/list-selector/UserList'
import Icon from '@insided/deprecated-preact-components/assets'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

interface State {
  isModalOpen: boolean
}

class AssignModerator extends Component<BulkActionComponentProps, State> {
  constructor() {
    super()
    this.state = {
      isModalOpen: false
    }
  }

  assign = async (user: User) => {
    const { performBulkAction, numberOfSelectedItems } = this.props

    const bulkAction = {
      successMessage: `${numberOfSelectedItems} topic(s) assigned to ${user.name}`,
      onClick: async (selectedTopics: any) =>
        await axios.post(
          `/community/api/bulk/process?moderatorId=${getInsidedData('user').userid}`,
          {
            action: 'assignModerator',
            topics: getIdAndContentTypeFromTopics(selectedTopics),
            params: {
              assignedTo: Number(user.id)
            }
          }
        )
    }

    performBulkAction(bulkAction)
  }

  unassign = async () => {
    const { performBulkAction, numberOfSelectedItems } = this.props

    const bulkAction = {
      successMessage: `${numberOfSelectedItems} topic(s) unassigned`,
      onClick: async (selectedTopics: any) =>
        await performBulkActionForTopics(selectedTopics, 'unassignModerator')
    }

    performBulkAction(bulkAction)
  }

  render() {
    const user = getInsidedData('user')

    return (
      <DynamicUserList
        align='right'
        buttonTitle={
          <div>
            <Icon icon='person' width={16} height={16} />
            Assign moderator
          </div>
        }
        header={() => (
          <Buttons
            assignToMe={async () =>
              await this.assign({
                id: user.userid,
                name: user.name
              })}
            unassign={this.unassign}
          />
        )}
        onUserClick={this.assign}
        newStyle
        placeholder='Search for moderator'
        fetchUrl='/member/getModerators?query='
        feature='assign-moderator'
      />
    )
  }
}

const Buttons = ({ assignToMe, unassign }: { assignToMe: () => void, unassign: () => void }) => {
  const user = getInsidedData('user')

  return (
    <div className='bulk-actions-assign-moderator-buttons'>
      <UserListItem user={{ id: '', name: 'Unassign' }} onClick={unassign} customIcon='user' />
      <UserListItem
        user={{
          id: user.userid,
          name: user.name + ' (assign to me)',
          avatar: user.avatar
        }}
        onClick={assignToMe}
      />
    </div>
  )
}

export default AssignModerator
